import { render, staticRenderFns } from "./webapp.vue?vue&type=template&id=0d5fad48&scoped=true"
import script from "./webapp.vue?vue&type=script&lang=js"
export * from "./webapp.vue?vue&type=script&lang=js"
import style0 from "./webapp.vue?vue&type=style&index=0&id=0d5fad48&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5fad48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5fad48')) {
      api.createRecord('0d5fad48', component.options)
    } else {
      api.reload('0d5fad48', component.options)
    }
    module.hot.accept("./webapp.vue?vue&type=template&id=0d5fad48&scoped=true", function () {
      api.rerender('0d5fad48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/head/webapp.vue"
export default component.exports